import { Outlet } from 'react-router-dom';

import ColorModeToggle from '@/components/ui/color-mode-toggle';
import { useDocumentTitle } from '@/hooks/use-document-title';

/**
 * Auth Layout
 * Layout for authentication pages (login, logout, verify, etc.)
 * No user header or navigation - just centered content
 */
export default function AuthLayout() {
  useDocumentTitle();

  return (
    <main className="bg-background flex min-h-screen flex-col">
      <div className="flex flex-row justify-end gap-5 px-4 py-2 sm:gap-4">
        <ColorModeToggle />
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-5 sm:gap-4">
        <Outlet />
      </div>
    </main>
  );
}
